// src/pages/Contact.js
import React, { useState } from "react";
import toast from "react-hot-toast";

export default function Contact() {
  const [form, setForm] = useState({ name: "", email: "", subject: "", message: "" });
  const [sent, setSent] = useState(false);

  const handleSubmit = async (e) => {
    e.preventDefault();
    // Aquí puedes integrar EmailJS, Formspree o Firebase Functions para envío de emails
    // Por ahora abre mailto como fallback
    const body = `Nombre: ${form.name}\nEmail: ${form.email}\n\n${form.message}`;
    window.open(`mailto:hola@conelcorazon.co?subject=${encodeURIComponent(form.subject)}&body=${encodeURIComponent(body)}`);
    setSent(true);
    toast.success("¡Mensaje enviado!");
  };

  return (
    <div className="page-pad content-page">
      <h1>Contáctanos</h1>
      <div className="contact-grid">
        <div className="contact-info">
          <h3>Estamos aquí para ayudarte</h3>
          <div className="contact-item">
            <span>📧</span>
            <div>
              <strong>Email</strong>
              <a href="mailto:hola@conelcorazon.co">hola@conelcorazon.co</a>
            </div>
          </div>
          <div className="contact-item">
            <span>📱</span>
            <div>
              <strong>WhatsApp</strong>
              <a href="https://wa.me/573000000000" target="_blank" rel="noreferrer">+57 300 000 0000</a>
            </div>
          </div>
          <div className="contact-item">
            <span>📸</span>
            <div>
              <strong>Instagram</strong>
              <a href="https://instagram.com/conelcorazon.co" target="_blank" rel="noreferrer">@conelcorazon.co</a>
            </div>
          </div>
          <div className="contact-item">
            <span>⏰</span>
            <div>
              <strong>Horario de atención</strong>
              <span>Lunes a Viernes 8am – 6pm</span>
            </div>
          </div>
        </div>

        <form className="contact-form" onSubmit={handleSubmit}>
          <div className="form-field">
            <label>Nombre</label>
            <input required value={form.name} onChange={e => setForm(f => ({...f, name: e.target.value}))} />
          </div>
          <div className="form-field">
            <label>Email</label>
            <input type="email" required value={form.email} onChange={e => setForm(f => ({...f, email: e.target.value}))} />
          </div>
          <div className="form-field">
            <label>Asunto</label>
            <input required value={form.subject} onChange={e => setForm(f => ({...f, subject: e.target.value}))} />
          </div>
          <div className="form-field">
            <label>Mensaje</label>
            <textarea required rows={5} value={form.message} onChange={e => setForm(f => ({...f, message: e.target.value}))} />
          </div>
          <button type="submit" className="btn-primary btn-full">Enviar mensaje</button>
        </form>
      </div>
    </div>
  );
}
